import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconTypes } from '@shared/v2';
import { SdvorIconComponent } from '../icon';

type SystemMessageTypes = 'error' | 'warning';

@Component({
  selector: 'sd-system-message',
  templateUrl: './system-message.component.html',
  styleUrls: ['./system-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent],
  host: {
    '[class.error]': 'type() === "error"',
    '[class.warning]': 'type() === "warning"',
  },
})
export class SystemMessageComponent {
  type = input.required<SystemMessageTypes>();

  protected readonly iconTypes = IconTypes;
}
